import styled from '@emotion/styled';

export const ChipRoot = styled.span<{ $disabled?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  padding: 4px;
  border-radius: 4px;
  background: var(--dk-bg-subtle, #f9fafb);
  border: 1px solid var(--dk-line, #e7e9ec);
  overflow: hidden;
  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const Avatar = styled.span`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 999px;
  overflow: hidden;
  background: var(--dk-bg-strong, #e7e9ec);
  color: var(--dk-text-secondary, #888d96);
  font-size: 10px;
  font-weight: 600;
  line-height: 1;

  & > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Label = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  color: var(--dk-text, #000000);
  font-family: Pretendard;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const RemoveButton = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  color: var(--dk-text-secondary, #888d96);
  cursor: pointer;
  transition: color 120ms ease;

  &:hover {
    color: var(--dk-text-primary, #34383d);
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
